export default {
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.overview': 'Overview',
  'dashboard.qrcodes': 'QR Codes',
  'dashboard.links': 'Short Links',
  'dashboard.biolinks': 'Bio Links',
  'dashboard.analytics': 'Analytics',
  
  // Stats
  'stats.totalClicks': 'Total Clicks',
  'stats.totalScans': 'Total Scans',
  'stats.totalViews': 'Total Views',
  'stats.today': 'Today',
  'stats.growth': 'Growth',
  
  // QR Code
  'qr.create': 'Create QR Code',
  'qr.name': 'QR Code Name',
  'qr.url': 'Target URL',
  'qr.color': 'QR Color',
  'qr.bgColor': 'Background Color',
  'qr.size': 'Size',
  'qr.preview': 'Preview',
  'qr.download': 'Download',
  'qr.scans': 'Scans',
  'qr.created': 'Created',
  'qr.lastScanned': 'Last Scanned',
  'qr.noScans': 'No scans yet',
  
  // Short Link
  'link.create': 'Create Short Link',
  'link.name': 'Link Name',
  'link.original': 'Original URL',
  'link.short': 'Short Code',
  'link.clicks': 'Clicks',
  'link.copy': 'Copy',
  'link.copied': 'Copied!',
  
  // Bio Link
  'bio.create': 'Create Bio Link',
  'bio.username': 'Username',
  'bio.title': 'Title',
  'bio.bio': 'Bio',
  'bio.avatar': 'Avatar',
  'bio.addLink': 'Add Link',
  'bio.linkTitle': 'Link Title',
  'bio.linkUrl': 'Link URL',
  'bio.theme': 'Theme',
  'bio.light': 'Light',
  'bio.dark': 'Dark',
  'bio.accentColor': 'Accent Color',
  'bio.preview': 'Preview',
  'bio.views': 'Views',
  
  // Actions
  'action.create': 'Create',
  'action.save': 'Save',
  'action.cancel': 'Cancel',
  'action.delete': 'Delete',
  'action.edit': 'Edit',
  'action.view': 'View',
  'action.share': 'Share',
  
  // Messages
  'message.created': 'Created successfully',
  'message.updated': 'Updated successfully',
  'message.deleted': 'Deleted successfully',
  'message.error': 'An error occurred',
  'message.fillRequired': 'Please fill in required fields',
  
  // Navigation
  'nav.home': 'Home',
  'nav.logout': 'Logout',
};
